/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountInventoryInfoRequest model module.
 * @module model/AccountControllerDtoAccountInventoryInfoRequest
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoRequest {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoRequest</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoRequest
     * @param accountNo {Number} 
     */
    constructor(accountNo) { 
        
        AccountControllerDtoAccountInventoryInfoRequest.initialize(this, accountNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, accountNo) { 
        obj['accountNo'] = accountNo;
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoRequest} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoRequest} The populated <code>AccountControllerDtoAccountInventoryInfoRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoRequest();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AccountControllerDtoAccountInventoryInfoRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

AccountControllerDtoAccountInventoryInfoRequest.RequiredProperties = ["accountNo"];

/**
 * @member {Number} accountNo
 */
AccountControllerDtoAccountInventoryInfoRequest.prototype['accountNo'] = undefined;






export default AccountControllerDtoAccountInventoryInfoRequest;

